import Vuex from 'vuex'
import Vue from 'vue'
import userInfo from './userInfo'
import menu from './menu'
import tabs from './tabs'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    systemName: '517 Web Framework',
    currDepositWorksite: ''
  },
  mutations: {
    updateDepositWs(state, payload) {
      state.currDepositWorksite = payload;
    }
  },
  modules: {
    userInfo,
    menu,
    tabs
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js